import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { block } from '../../utils/cn';
import { LabelFilterItem } from './LabelFilterItem';
import { LabelFilterToggler } from './LabelFilterToggler';
import './LabelFilters.css';
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('label-filters');
export function LabelFilters(_ref) {
  var filter = _ref.filter,
    onItemRemove = _ref.onItemRemove,
    onItemAdd = _ref.onItemAdd,
    className = _ref.className;
  return filter ? /*#__PURE__*/_jsx("div", {
    className: b(null, className),
    children: Object.entries(filter).map(function (_ref2) {
      var _settings$title, _settings$value$, _settings$value;
      var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        settings = _ref3[1];
      var count = settings === null || settings === void 0 ? void 0 : settings.value.length;
      var more = count > 1 ? " +".concat(count - 1) : '';
      var value = (_settings$title = settings === null || settings === void 0 ? void 0 : settings.title) !== null && _settings$title !== void 0 ? _settings$title : "".concat((_settings$value$ = settings === null || settings === void 0 || (_settings$value = settings.value) === null || _settings$value === void 0 ? void 0 : _settings$value[0]) !== null && _settings$value$ !== void 0 ? _settings$value$ : '').concat(more);
      return (settings === null || settings === void 0 ? void 0 : settings.active) === false ? /*#__PURE__*/_jsx(LabelFilterToggler, {
        name: name,
        className: b('toggler'),
        onClick: onItemAdd,
        value: value,
        isMulty: count > 1
      }, name) : /*#__PURE__*/_jsx(LabelFilterItem, {
        name: name,
        className: b('item'),
        onItemRemove: onItemRemove,
        value: value
      }, name);
    })
  }) : null;
}
// #sourceMappingURL=LabelFilters.js.map